import clsx from 'clsx';
import style from './style.module.scss';
import { ItemMenu } from './Item';

export const Menu = ({ menu, classNames, isFirstMenuMobile = false, isUserConnected = false }) => {
    return (
        <ul className={clsx(style.menu, classNames)}>
            {menu &&
                Object.values(menu).map((menuItem, id) => {
                    const blockUserAccess =
                        menuItem.meta.block_if_user_not_connected &&
                        menuItem.meta.block_if_user_not_connected[0] &&
                        Boolean(parseInt(menuItem.meta.block_if_user_not_connected[0])) === true &&
                        !isUserConnected;
                    return (
                        <li key={id} className={isFirstMenuMobile ? style.menuItemMobile : style.menuItem}>
                            <ItemMenu item={menuItem} blockUserAccess={blockUserAccess} />
                        </li>
                    );
                })}
        </ul>
    );
};
